module.exports = __webpack_public_path__ + "img/pic-2-2.79bb8c61.png";